import { Text } from '@/ui/typography';
import { dateString } from '@/utils/helpers';
import { getFontSize } from '../utils';

export const DateColumn = ({ date, windowWidth }) => {
  const fontSize = getFontSize(windowWidth);

  return (
    <Text $fontSize={fontSize}>
      {!!date ? dateString(new Date(date), true, true) : '-'}
    </Text>
  );
};

